import { z } from "zod";

/**
 * Twilio purchased phone number details
 */
export const PhoneNumberPurchasedSchema = z.object({
  accountSid: z.string(),
  addressSid: z.string().optional(),
  apiVersion: z.string().optional(),
  beta: z.boolean().optional(),
  dateCreated: z.union([z.date(), z.string()]).optional(),
  dateUpdated: z.union([z.date(), z.string()]).optional(),
  friendlyName: z.string().optional(),
  phoneNumber: z.string().optional(),
  sid: z.string().optional()
});

export type PhoneNumberPurchased = z.infer<typeof PhoneNumberPurchasedSchema>;
